var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message"},[_c('date-formatter',{staticClass:"caption",attrs:{"value":_vm.value.sentAt}}),_vm._v(" "),_c('p',{staticClass:"body-1",domProps:{"innerHTML":_vm._s(_vm.message)}}),_vm._v(" "),(_vm.preview)?_c(_vm.preview,{tag:"component",attrs:{"value":this.value.data}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a99ad0c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/messenger/Message.vue
// module id = null
// module chunks = 